import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../utils/colors.mjs';
import { divider, dividerColor } from './divider.vanilla.mjs';

const Divider = forwardRef(
  ({
    className: classNameFromProps,
    color = "black010",
    orientation = "horizontal",
    style: styleFromProps,
    variant,
    ...props
  }, forwardedRef) => {
    const className = classNames(
      divider({ orientation, variant }),
      classNameFromProps
    );
    const style = Object.assign(
      {},
      assignInlineVars({
        [dividerColor]: getColor(color)
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        "aria-orientation": orientation,
        "data-scope": "divider",
        "data-part": "root",
        role: "separator",
        className,
        style,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledDiv = styled("div");
Divider.displayName = "Divider";

export { Divider };
//# sourceMappingURL=Divider.mjs.map
